// Registered style module for the ai-topic-sidebar component.
// Covers sidebar layout, new-topic button, topic list, row styles, and loading spinner.

const styleElement = document.createElement("dom-module");

styleElement.innerHTML = /*html*/`<template>
    <style>
    :host {
      display: flex;
      flex-direction: column;
      height: 100%;
      min-height: 0;
      box-sizing: border-box;
      width: 338px;
      max-width: 100%;
      flex-shrink: 0;
    }

    .ai-topic-sidebar {
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      height: 100%;
      min-height: 0;
      overflow: hidden;
      background: #fafafa;
      padding: 0 24px 24px;
    }

    .ai-topic-sidebar__new-wrap {
      position: sticky;
      top: 0;
      z-index: 2;
      flex-shrink: 0;
      padding-top: 25px;
      padding-bottom: 8px;
      margin-bottom: 0;
      background: #fafafa;
    }

    .ai-topic-sidebar__new {
      box-sizing: border-box;
      display: flex;
      width: 100%;
      max-width: 290px;
      align-items: center;
      justify-content: center;
      gap: 4px;
      padding: 10px 16px;
      border: 0;
      border-radius: 8px;
      background: #3570d2;
      color: #ffffff;
      font-family: "Lato", sans-serif;
      font-weight: 700;
      font-size: 16px;
      line-height: 22px;
      cursor: pointer;
    }

    .ai-topic-sidebar__new-text {
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .ai-topic-sidebar__new img {
      width: 20px;
      height: 20px;
      flex-shrink: 0;
      display: block;
    }

    .ai-topic-sidebar__error-wrap {
      flex-shrink: 0;
      margin-bottom: 8px;
      max-width: 290px;
    }

    .ai-topic-sidebar__list {
      margin: 0;
      padding: 0 0 8px;
      list-style: none;
      display: flex;
      flex-direction: column;
      gap: 2px;
      width: 100%;
      max-width: 290px;
      flex: 1 1 auto;
      min-height: 0;
      overflow-x: hidden;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
    }

    .ai-topic-sidebar__row-wrap {
      position: relative;
      display: flex;
      align-items: center;
      border-radius: 4px;
    }

    .ai-topic-sidebar__row-wrap.is-selected {
      background: #e3e3e3;
    }

    .ai-topic-sidebar__row {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      flex: 1 1 auto;
      min-width: 0;
      margin: 0;
      padding: 14px 4px 14px 12px;
      border: 0;
      border-radius: 4px;
      background: transparent;
      text-align: left;
      cursor: pointer;
      font-family: "Lato", sans-serif;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #424242;
    }

    .ai-topic-sidebar__row:focus-visible {
      outline: 2px solid #3570d2;
      outline-offset: 2px;
    }

    .ai-topic-sidebar__menu-trigger {
      flex-shrink: 0;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      margin: 0;
      padding: 14px 12px 14px 4px;
      border: 0;
      background: transparent;
      cursor: pointer;
    }

    .ai-topic-sidebar__menu-trigger img {
      width: 20px;
      height: 20px;
      display: block;
    }

    .ai-topic-sidebar__menu-trigger:focus-visible {
      outline: 2px solid #3570d2;
      outline-offset: 2px;
      border-radius: 4px;
    }

    .ai-topic-sidebar__menu {
      position: absolute;
      top: calc(100% - 18px);
      right: 0;
      z-index: 10;
      width: 124px;
      padding: 12px 0;
      border-radius: 8px;
      background: #ffffff;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }

    .ai-topic-sidebar__menu-item {
      display: flex;
      align-items: center;
      gap: 7px;
      width: 100%;
      padding: 10px 16px;
      border: 0;
      background: transparent;
      text-align: left;
      cursor: pointer;
    }

    .ai-topic-sidebar__menu-item-icon {
      width: 16.5px;
      height: 18.5px;
      flex-shrink: 0;
      display: block;
    }

    .ai-topic-sidebar__menu-item-label {
      font-family: "Lato", sans-serif;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0;
      color: #D0012B;
      cursor: pointer;
    }

    .ai-topic-sidebar__menu-item:hover {
      background: #f4f4f4;
    }

    .ai-topic-sidebar__menu-item:focus-visible {
      outline: 2px solid #3570d2;
      outline-offset: -2px;
    }

    .ai-topic-sidebar__label {
      flex: 1 1 auto;
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .ai-topic-sidebar__sentinel {
      height: 1px;
      width: 100%;
      flex-shrink: 0;
    }

    .ai-topic-sidebar__load-more {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 12px 0;
      gap: 8px;
    }

    .ai-topic-sidebar__spinner {
      width: 20px;
      height: 20px;
      box-sizing: border-box;
      border: 2px solid #e0e0e0;
      border-top-color: #3570d2;
      border-radius: 50%;
      animation: topicSpin 0.7s linear infinite;
    }

    @keyframes topicSpin {
      to { transform: rotate(360deg); }
    }
    </style>
</template>`;
styleElement.register("topic-sidebar-style");
